import {EEventSource} from '../events/IEvents';
export interface ISearchRefinements {
	[key: string]: string[];
}

export interface ISearchParams {
	refinements?: ISearchRefinements,
	sortingRule?: string,
	searchQuery?: string,
	page?: number,
	limitParam?: number,
	eventSource?: EEventSource
}

export interface ISearchSuggestionsParams {
	searchQuery: string;
	limit?: number;
}

export interface IPopularSearchesParams {
	limit?: number;
}

export interface ISearchOptions {
	shouldEmitEvents?: boolean,
	isBot?: boolean
}

export interface IContentCardConfig {
	size: number,
	height?: number,
	position: number,
	width?: number
}

export interface IContentCard {
	size?: number,
	height?: number,
	width?: number,
	position: number,
	contentfulData: object
}

export interface IContentCards {
	[key: number]: IContentCard;
}

export interface ICustomElementInclude {
	size?: number;
	width?:  number;
	height?: number;
	position: number;
	positionMOB?: number;
	sizeMOB?: number;
	contentfulData: Record<string, unknown>;
	hideInSmallGrid: boolean;
}

// KEY = POSITION ELEMENT FOR RAPID ACCESS TO THE PRODUCT INCLUDE
export interface ICustomElementIncludes extends Map<number | `offset-tile-${number}` | `offset-tile-mob-${number}`, ICustomElementInclude> {}

export type TSearchRefinement = string[] | string;

export enum ESearchProvider {
	SFCC = 'sfcc',
	ALGOLIA = 'algolia'
}

export enum ESearchType {
	QUICK_SEARCH = 'quickSearch',
	PAGE = 'page'
}
